import styles from './busType.module.css';
import Slider from './slider';

/* 25인승 소형 실내 사진은 새 자료가 없어 기존 사진 중 화질이 쓸 만한 3장만 남겼다 */
const busImages = [
  { url: '/image/smallBus/interior1.jpg?v=2' },
  { url: '/image/smallBus/interior2.jpg?v=2' },
  { url: '/image/smallBus/interior3.jpg?v=2' },
];

const SmallBus = () => {
  return (
      <section className={styles.container}>
        <h1 className={styles.title}>25인승 소형</h1>

        <section>
          <p className={styles.busDetail}>
            각종 소규모 단체, 동호회, 교회, 학원, 유치원 등에서 많이 이용하고 있는 25인승 버스입니다. <br />
            장소에 구애받지 않고 이동과 기동성이 뛰어나고 비용이 저렴하여 <br />
            소규모 단체의 여행에 이용됩니다.
          </p>

          <img
            className={styles.exteriorPhoto}
            src='/image/smallBusExterior.jpg?v=2'
            alt='25인승 소형버스 외관'
          />

          <h2 className={styles.imageTitle}>차량 사진</h2>

          <Slider imageList={busImages} />
        </section>
      </section>
  )
};

export default SmallBus;